import mixin from '../../mixins/Mixin.js';
export default (editor, config = {}) => {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  var modal = null;
  var self;
  var playlist = [];
  var page = 0;
  var total_number = 1;
  var initialise = false;
  domc.addType('playlist', {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': 'playlist',
          tagName: 'div',
          src: '',
          width: '100%',
          height: '100%',
          traits: [
            {
              type: 'text',
              label: 'src',
              name: 'src',
              changeProp: 1,
            },
            {
              type: 'checkbox',
              label: 'autoplay',
              name: 'autoplay',
              changeProp: 1,
            },
            {
              type: 'checkbox',
              label: 'loop',
              name: 'loop',
              changeProp: 1,
            },
            {
              type: 'checkbox',
              label: 'controls',
              name: 'controls',
              changeProp: 1,
            },
          ],
        }),
        init() {
          this.listenTo(this, 'change:src', this.updateSrc);
          this.listenTo(this, 'change:autoplay', this.updateAutoplay);
          this.listenTo(this, 'change:loop', this.updateLoop);
          this.listenTo(this, 'change:controls', this.updateControl);
        },
        toHTML() {
          return this.view.el.getAttribute('data-gjs-type') == 'playlist'
            ? this.view.el.outerHTML
            : '';
        },
        updateSrc() {
          this.view.el.setAttribute('src', this.get('src'));
          this.view.getIframe().src = this.get('src');
          this.updateAutoplay();
          this.updateLoop();
          this.updateControl();
        },
        updateAutoplay() {
          this.updateUrlVid(this.get('autoplay'), 'a', 1);
        },
        updateLoop() {
          this.updateUrlVid(this.get('loop'), 'loop', 1);
        },
        updateControl() {
          this.updateUrlVid(this.get('controls'), 'sc', 1);
        },
        updateUrlVid(valueCheck, option, val) {
          var url = this.get('src');
          if (url.indexOf(option + '=' + val) > -1 && valueCheck) {
            return;
          }
          if (valueCheck) {
            if (url.indexOf('?') === -1) {
              url += '?' + option + '=' + val;
            } else {
              url += '&' + option + '=' + val;
            }
          } else {
            if (url.indexOf('?' + option + '=' + val) !== -1) {
              url = url.replace('?' + option + '=' + val, '');

              var index = url.indexOf('&');
              if (index !== -1) url = url.replace('&', '?');
            } else if (url.indexOf('&' + option + '=' + val) !== -1) {
              url = url.replace('&' + option + '=' + val, '');
            }
          }
          this.set('src', url);
          this.view.getIframe().src = url;
        },
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName == 'div') {
            result = { type: 'playlist' };
          }
          return result;
        },
      },
    ),
    view: defaultView.extend({
      events: {
        dblclick: 'openModal',
      },
      initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
        self = this;
        this.model.listenTo(this.model, 'active', self.insertIframe);
        modal = editor.Modal;
        modal.setTitle(config.translate);
      },
      getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('iframe');
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.src = this.model.get('src');
          ifrm.id = 'playlist-' + mixin.methods.makeId();
          ifrm.width = this.model.get('width');
          ifrm.height = this.model.get('height');
          ifrm.style = 'border:none;overflow:hidden';
          ifrm.scrolling = 'no';
          ifrm.frameborder = '0';
          ifrm.allowtransparency = 'true';
          ifrm.allow = 'encrypted-media';

          this.iframe = ifrm;
        }
        return this.iframe;
      },
      insertIframe() {
        self.el.appendChild(self.getIframe());
        document.getElementById('CanvOverlay').style.display = 'block';
        self.openModal();
      },
      noVideos() {
        modal.setContent(`<div id="modal-playlist-list" class="container" style=" min-height: 100px;padding:5px;display: inline-block;max-height: 660px; overflow-y: auto">
                                        <span><img src="
                    static/images/nofound.png" alt="nofound image"></span>
                                   </div>`);
      },
      reloadPlayersList() {
        page = page + 1;
        var modalContent = document.getElementById('modal-playlist-list');
        if (playlist.length < total_number) {
          self.showLoader();
          config
            .http(window.ApiToken)
            .get(
              config.routing.generate(config.api_routing_playlist, {
                id: '',
                page: page,
                nbParPage: 20,
                client: config.client.paramsClient.client,
              }),
            )
            .then(
              function(response) {
                self.hideLoader();
                if (response.data.code === 200) {
                  var selected = 0;
                  total_number = response.data.nombre_total;
                  if (response.data.playlists.length === 0 && playlist.length === 0) {
                    self.noVideos();
                  } else {
                    response.data.playlists.forEach(val => {
                      var element = document.createElement('div');
                      element.id = 'i' + val.id;
                      element.className = 'player-item';
                      var srcImage;
                      if (val.logo && val.logo !== '') {
                        srcImage = val.logo;
                      } else {
                        srcImage = '/static/images/vignette.jpg';
                      }
                      element.innerHTML =
                        `<img src="` +
                        srcImage +
                        `" alt="Card image" style="height: 100px;cursor: pointer">
                                        <div class="vidPlayer">
                                             <h5  class="descriptionPlayer">` +
                        val.title +
                        `</h5>
                                        </div>`;
                      modalContent.appendChild(element);
                    });

                    response.data.playlists.forEach(val => {
                      document.getElementById('i' + val.id).addEventListener('click', function() {
                        if (selected != 0) {
                          document
                            .getElementById('i' + selected)
                            .style.removeProperty('background-color');
                          document
                            .getElementById('i' + selected)
                            .firstElementChild.style.removeProperty('opacity');
                        }
                        selected = val.id;
                        document.getElementById('i' + val.id).style.backgroundColor =
                          'rgba(255,255,255,0.1)';
                        document.getElementById('i' + val.id).firstElementChild.style.opacity =
                          '0.8';
                        self.getIframe().src = val.lien;
                        self.model.set('src', val.lien);
                        self.model.updateAutoplay();
                        self.model.updateLoop();
                        self.model.updateControl();
                      });
                      document
                        .getElementById('i' + val.id)
                        .addEventListener('dblclick', function() {
                          document.querySelector('.gjs-mdl-btn-close').click();
                        });
                    });

                    playlist = playlist.concat(response.data.playlists);
                    if (playlist.length === total_number) {
                      document
                        .getElementById('modal-playlist-container')
                        .removeEventListener('scroll', function() {
                          var listElm = document.getElementById('modal-playlist-container');
                          if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                            self.reloadPlayersList();
                          }
                        });
                      self.hideLoader();
                    } else {
                      if (!initialise) {
                        document
                          .getElementById('modal-playlist-container')
                          .addEventListener('scroll', function() {
                            var listElm = document.getElementById('modal-playlist-container');
                            if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                              self.reloadPlayersList();
                            }
                          });
                        initialise = true;
                      }
                    }
                  }
                }
              },
              function(response) {
                self.hideLoader();
              },
            );
        }
      },
      hideLoader() {
        document.getElementById('loader-playlist-list').style.visibility = 'hidden';
      },
      showLoader() {
        document.getElementById('loader-playlist-list').style.visibility = 'visible';
      },
      onScroll() {
        var listElm = document.getElementById('modal-playlist-container');
        if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          self.reloadPlayersList();
        }
      },
      openModal() {
        page = 0;
        playlist = [];
        initialise = false;
        modal.setContent(`<div id="modal-playlist-container" class="players-list container">
                                       <div id="modal-playlist-list" class="players-wrapper"></div>
                                       <div id="loader-playlist-list" class="loader-4 center"><span></span></div>
                                   </div>`);
        self.reloadPlayersList();
        modal.open();
        modal.getModel().once('change:open', function() {
          document.getElementById('CanvOverlay').style.display = 'none';
          const getAllComponents = (model, result = []) => {
            result.push(model);
            model.components().each(mod => getAllComponents(mod, result));
            return result;
          };
          const all = getAllComponents(editor.DomComponents.getWrapper());

          for (var i = 0; i < all.length; i++) {
            let type = all[i].attributes.type;
            let src = all[i].attributes.src;
            if (type === 'player' || type === 'playlist' || type === 'live') {
              if (!src) {
                grapesjsEMP.editors[0].UndoManager.undo();
              }
            }
          }
        });
      },

      updateSrcField() {
        const src = this.model.get('src') || this.el.getAttribute('src') || this.getIframe().src;
        this.model.set('src', src + '?a=0');
      },

      render(...args) {
        defaultView.prototype.render.apply(this, args);
        if (this.model.get('src')) {
          this.model.set('src', this.model.get('src'));
          this.el.appendChild(this.getIframe());
        }
        this.updateClasses();
        this.updateAttributes();
        return this;
      },
    }),
  });
};



// WEBPACK FOOTER //
// ./src/plugins/playlist/components.js